import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.collections.item');
import { OnInit, ElementRef, ViewChild } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-collections-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.collections.item/view.scss */
@charset "UTF-8";
:host {
  display: block;
  height: 100%;
}

.drop-zone-active {
  border-color: #78716c !important;
  background-color: #fafaf9 !important;
}

/* ─── Extracted Text Formatting ─────────────────────── */
.extracted-text .text-block {
  position: relative;
  padding: 10px 14px;
  margin-bottom: 6px;
  border-left: 3px solid #e7e5e4;
  border-radius: 2px;
  line-height: 1.85;
  background: #fafaf9;
  transition: border-color 0.15s;
}
.extracted-text .text-block:hover {
  border-left-color: #a8a29e;
}
.extracted-text .text-block:last-child {
  margin-bottom: 0;
}

:host-context(.dark) .extracted-text .text-block,
.dark .extracted-text .text-block {
  border-left-color: #44403c;
  background: #1c1917;
}
:host-context(.dark) .extracted-text .text-block:hover,
.dark .extracted-text .text-block:hover {
  border-left-color: #78716c;
}`],
})
export class PageCollectionsItemComponent implements OnInit {
    @ViewChild('fileInput') fileInput: ElementRef;

    public collection: any = {};
    public documents: any[] = [];
    public loading: boolean = true;
    public uploading: boolean = false;
    public dragOver: boolean = false;
    public collectionId: string = '';
    public documentSearchText: string = '';
    public documentStatusFilter: string = 'all';
    public selectedDoc: any = null;
    public selectedDocTab: string = 'biblio';
    public selectedDocTabs: any[] = [
        { key: 'biblio', label: '서지정보' },
        { key: 'viewer', label: '원문보기' },
        { key: 'history', label: '처리이력' },
        { key: 'file', label: '파일정보' },
        { key: 'source', label: '출처정보' }
    ];
    public selectedDocIds: string[] = [];
    public showDeleted: boolean = false;
    public historyRows: any[] = [];
    public jobRows: any[] = [];
    public documentPage: number = 1;
    public documentPageSize: number = 10;
    public showLinkModal: boolean = false;
    public linkData: any = this.defaultLinkData();
    public SUPPORTED_FILE_EXTENSIONS: string[] = [
        'pdf', 'xml', 'json', 'csv', 'xls', 'xlsx', 'doc', 'docx',
        'hwp', 'hwpx', 'txt', 'md', 'jpg', 'jpeg', 'png', 'tif', 'tiff',
        'zip', 'mp3', 'wav', 'mp4'
    ];
    public SUPPORTED_FILE_ACCEPT: string = this.SUPPORTED_FILE_EXTENSIONS.map(ext => `.${ext}`).join(',');
    public supportedFileLabel: string = 'PDF, XML, JSON, CSV, XLSX, DOCX, HWP, TXT, 이미지, ZIP, 음성·영상';

    // PDF 보기 모달
    public showPdfModal: boolean = false;
    public pdfModalDoc: any = null;
    public pdfModalUrl: string = '';
    public pdfModalPreviewUrl: string = '';
    public pdfModalLoading: boolean = false;
    private pdfModalToken: number = 0;

    // 업로드 진행
    public uploadProgressPct: number = 0;
    public uploadFileName: string = '';
    public uploadQueue: any[] = [];

    // 내용 확인 모달
    public showPreviewModal: boolean = false;
    public previewDoc: any = null;
    public previewPages: string[] = [];
    public previewPagesHtml: string[] = [];
    public previewCurrentPage: number = 1;
    public previewTotalPages: number = 0;
    public previewLoading: boolean = false;
    public previewPageImgUrl: string = '';

    // 편집 모달
    public showEditModal: boolean = false;
    public editData: any = { title: '', description: '', tags: [] };
    public editNewTag: string = '';
    public editNewTagColor: string = '#6366f1';
    public allTags: any[] = [];
    public metadataEdit: any = {};

    public COLOR_PALETTE: string[] = [
        '#6366f1', '#8b5cf6', '#ec4899', '#ef4444', '#f97316',
        '#eab308', '#22c55e', '#14b8a6', '#06b6d4', '#3b82f6',
        '#78716c', '#475569'
    ];

    public documentStatusFilters: any[] = [
        { key: 'all', label: '전체' },
        { key: 'external', label: '링크 보관' },
        { key: 'archived', label: '원본 보관' },
        { key: 'pending', label: '분석 대기' },
        { key: 'processing', label: '원문 분석 중' },
        { key: 'completed', label: '활용 가능' },
        { key: 'failed', label: '분석 오류' },
        { key: 'cancelled', label: '분석 중단' },
        { key: 'trash', label: '휴지통' }
    ];

    // 개별 원문 분석 진행
    public registeringDocId: string = '';
    public registeringDocName: string = '';
    public registerProgress: string = '';
    public registerProgressPct: number = 0;
    public registerStep: number = 0;
    public registerStopped: boolean = false;
    public registerEta: string = '';
    private registerStartTime: number = 0;

    // 일괄 원문 분석 진행
    public batchRegistering: boolean = false;
    public batchTotal: number = 0;
    public batchCompleted: number = 0;
    public batchFailed: number = 0;
    public batchCurrentDoc: any = null;
    public batchStopped: boolean = false;
    public batchCurrentStep: number = 0;
    public batchOverallPct: number = 0;
    public batchDone: boolean = false;
    public batchDoneMessage: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        this.collectionId = WizRoute.segment.id;
        if (!this.collectionId) {
            this.service.href('/collections');
            return;
        }
        await this.load();
    }

    public async load() {
        this.loading = true;
        await this.service.render();

        const { code, data } = await wiz.call("detail", { id: this.collectionId, include_deleted: this.showDeleted ? "true" : "false" });
        if (code === 200) {
            this.collection = data.collection || {};
            this.documents = data.documents || [];
            this.allTags = data.all_tags || [];
            this.selectedDocIds = this.selectedDocIds.filter((id: string) => this.documents.some((doc: any) => doc.id === id));
            if (this.selectedDoc) {
                this.selectedDoc = this.documents.find((doc: any) => doc.id === this.selectedDoc.id) || null;
            }
            this.documentPage = Math.min(Math.max(this.documentPage, 1), this.documentTotalPages);
            if (this.collection.tags && typeof this.collection.tags === 'string') {
                try { this.collection.tags = JSON.parse(this.collection.tags); } catch (e) { this.collection.tags = []; }
            }
        } else {
            this.service.href('/collections');
            return;
        }

        this.loading = false;
        await this.service.render();
    }

    // ===== Computed Stats =====
    public get completedCount(): number {
        return this.documents.filter((d: any) => d.status === 'completed').length;
    }

    public get archivedCount(): number {
        return this.documents.filter((d: any) => d.status === 'archived').length;
    }

    public get availableCount(): number {
        return this.documents.filter((d: any) =>
            d.status === 'completed' || d.status === 'archived' || d.status === 'external' || d.is_external
        ).length;
    }

    public get localFileCount(): number {
        return this.documents.filter((d: any) => d.has_local_file && !d.is_external).length;
    }

    public get totalSize(): number {
        return this.documents.reduce((sum: number, d: any) => sum + (d.filesize || 0), 0);
    }

    public get collectionCompletionPct(): number {
        if (this.documents.length === 0) return 0;
        return Math.round((this.availableCount / this.documents.length) * 100);
    }

    public get externalCount(): number {
        return this.documents.filter((d: any) => d.status === 'external' || d.is_external).length;
    }

    public get processingCount(): number {
        return this.documents.filter((d: any) => d.status === 'processing').length;
    }

    public get pendingOnlyCount(): number {
        return this.documents.filter((d: any) =>
            this.isPdfDocument(d) && !d.is_external && d.status === 'pending'
        ).length;
    }

    public get failedCount(): number {
        return this.documents.filter((d: any) =>
            this.isPdfDocument(d) && !d.is_external && d.status === 'failed'
        ).length;
    }

    public get cancelledCount(): number {
        return this.documents.filter((d: any) =>
            this.isPdfDocument(d) && !d.is_external && d.status === 'cancelled'
        ).length;
    }

    public get retryableCount(): number {
        return this.documents.filter((d: any) =>
            this.isPdfDocument(d) &&
            !d.is_external &&
            (d.status === 'pending' || d.status === 'failed' || d.status === 'cancelled')
        ).length;
    }

    public get filteredDocuments(): any[] {
        let result = this.documents;

        if (this.documentStatusFilter === 'trash') {
            result = result.filter((doc: any) => !!doc.deleted);
        } else {
            result = result.filter((doc: any) => !doc.deleted);
        }

        if (this.documentStatusFilter !== 'all') {
            if (this.documentStatusFilter !== 'trash') {
                result = result.filter((doc: any) => doc.status === this.documentStatusFilter);
            }
        }

        if (this.documentSearchText.trim()) {
            const q = this.documentSearchText.trim().toLowerCase();
            result = result.filter((doc: any, index: number) => [
                doc.filename || '',
                this.documentTitle(doc),
                this.documentCatalogNo(doc, index),
                this.documentFormat(doc),
                this.statusText(doc.status),
                doc.source_url || '',
                doc.hflib_title || '',
                doc.hflib_author || '',
                doc.hflib_publication || '',
                doc.hflib_isbn || '',
                doc.hflib_volume || '',
                doc.nahf_article_title || '',
                doc.nahf_author_intro || '',
                doc.nahf_book_intro || '',
                JSON.stringify(doc.nahf_biblio || {}),
                String(doc.page_count || '')
            ].join(' ').toLowerCase().includes(q));
        }

        return result;
    }

    public get documentTotalPages(): number {
        return Math.max(1, Math.ceil(this.filteredDocuments.length / this.documentPageSize));
    }

    public get currentDocumentPage(): number {
        return Math.min(Math.max(this.documentPage, 1), this.documentTotalPages);
    }

    public get documentPageStart(): number {
        if (this.filteredDocuments.length === 0) return 0;
        return (this.currentDocumentPage - 1) * this.documentPageSize;
    }

    public get documentPageEnd(): number {
        return Math.min(this.documentPageStart + this.documentPageSize, this.filteredDocuments.length);
    }

    public get paginatedDocuments(): any[] {
        return this.filteredDocuments.slice(this.documentPageStart, this.documentPageEnd);
    }

    public get visibleDocumentPages(): number[] {
        const total = this.documentTotalPages;
        const current = this.currentDocumentPage;
        const pages: number[] = [];
        const start = Math.max(1, Math.min(current - 2, total - 4));
        const end = Math.min(total, start + 4);
        for (let page = start; page <= end; page++) pages.push(page);
        return pages;
    }

    public getTagColor(tagName: string): string {
        const tag = this.allTags.find((t: any) => t.name === tagName);
        return tag?.color || '#78716c';
    }

    public async setDocumentStatusFilter(status: string) {
        this.documentStatusFilter = status;
        this.showDeleted = status === 'trash';
        this.documentPage = 1;
        this.selectedDoc = null;
        await this.load();
        await this.service.render();
    }

    public async onDocumentSearch() {
        this.documentPage = 1;
        this.selectedDoc = null;
        await this.service.render();
    }

    public async setDocumentPage(page: number) {
        this.documentPage = Math.min(Math.max(page, 1), this.documentTotalPages);
        await this.service.render();
    }

    public isDocSelected(doc: any): boolean {
        return this.selectedDocIds.indexOf(doc.id) >= 0;
    }

    public async toggleDocSelection(doc: any, event?: Event) {
        if (event) event.stopPropagation();
        const idx = this.selectedDocIds.indexOf(doc.id);
        if (idx >= 0) this.selectedDocIds.splice(idx, 1);
        else this.selectedDocIds.push(doc.id);
        await this.service.render();
    }

    public async toggleAllVisibleDocuments() {
        const ids = this.paginatedDocuments.map((doc: any) => doc.id);
        const allSelected = ids.length > 0 && ids.every((id: string) => this.selectedDocIds.indexOf(id) >= 0);
        if (allSelected) this.selectedDocIds = this.selectedDocIds.filter((id: string) => ids.indexOf(id) < 0);
        else {
            for (const id of ids) if (this.selectedDocIds.indexOf(id) < 0) this.selectedDocIds.push(id);
        }
        await this.service.render();
    }

    public async bulkAction(action: string) {
        if (this.selectedDocIds.length === 0) return;
        const { code } = await wiz.call("bulk_action", {
            collection_id: this.collectionId,
            action,
            ids: JSON.stringify(this.selectedDocIds)
        });
        if (code === 200) {
            this.selectedDocIds = [];
            await this.load();
        }
    }

    public exportCsv() {
        window.open(`/wiz/api/page.collections.item/export_csv?collection_id=${encodeURIComponent(this.collectionId)}`, '_blank');
    }

    public collectionCatalogNo(): string {
        const raw = (this.collectionId || '').replace(/-/g, '').toUpperCase();
        return `DNAH-COL-${raw.slice(0, 8) || 'NEW'}`;
    }

    public collectionCategory(): string {
        const tags = this.collection.tags || [];
        if (tags.length > 0) return tags[0];
        return '일반 연구자료';
    }

    public documentCatalogNo(doc: any, index: number): string {
        const raw = (doc.id || '').replace(/-/g, '').toUpperCase();
        if (raw) return `DNAH-DOC-${raw.slice(0, 8)}`;
        return `DNAH-DOC-${String(index + 1).padStart(4, '0')}`;
    }

    public documentTitle(doc: any): string {
        if (doc?.nahf_article_title) return doc.nahf_article_title;
        if (doc?.hflib_title) return doc.hflib_title;
        const filename = doc?.filename || '';
        return filename.replace(/\.[^/.]+$/, '') || '제목 없는 자료';
    }

    public documentFormat(doc: any): string {
        const fileType = String(doc?.file_type || '').trim();
        if (fileType) return fileType.toUpperCase();
        const filename = doc.filename || '';
        const ext = filename.includes('.') ? filename.split('.').pop() : '';
        return (ext || '파일').toUpperCase();
    }

    public isPdfDocument(doc: any): boolean {
        return this.documentFormat(doc) === 'PDF';
    }

    public isSupportedFile(file: File): boolean {
        const filename = (file?.name || '').toLowerCase();
        const ext = filename.includes('.') ? filename.split('.').pop() || '' : '';
        return this.SUPPORTED_FILE_EXTENSIONS.indexOf(ext) >= 0;
    }

    public isRegisterableDocument(doc: any): boolean {
        return this.isPdfDocument(doc) &&
            !doc?.is_external &&
            (doc?.status === 'pending' || doc?.status === 'failed' || doc?.status === 'cancelled');
    }

    public documentCoverUrl(doc: any): string {
        if (!doc || doc.cover_fallback_failed) return '';
        if (doc.cover_failed) return doc.cover_fallback_url || '';
        return doc.cover_url || doc.cover_fallback_url || '';
    }

    public async onCoverError(doc: any) {
        if (doc) {
            const currentUrl = this.documentCoverUrl(doc);
            if (!doc.cover_failed && doc.cover_fallback_url && currentUrl !== doc.cover_fallback_url) {
                doc.cover_failed = true;
            } else {
                doc.cover_failed = true;
                doc.cover_fallback_failed = true;
            }
        }
        await this.service.render();
    }

    public canOpenPdf(doc: any): boolean {
        return !!(doc?.pdf_url || doc?.has_local_file || doc?.source_url);
    }

    public async openPdf(doc: any, event?: Event) {
        if (event) event.stopPropagation();
        if (!this.canOpenPdf(doc)) {
            await this.service.modal.show({
                title: '자료 없음',
                message: '열 수 있는 원문 파일이나 링크가 없습니다.',
                action: '확인',
                cancel: false
            });
            return;
        }

        const url = doc.pdf_url || `/api/pdf/${doc.id}/${this.collectionId}/file`;
        if (!this.isPdfDocument(doc)) {
            window.open(url, '_blank', 'noopener');
            return;
        }

        const token = ++this.pdfModalToken;
        this.pdfModalDoc = doc;
        this.pdfModalUrl = '';
        this.pdfModalPreviewUrl = this.documentCoverUrl(doc) || (this.isPdfDocument(doc) ? `/api/pdf/${doc.id}/${this.collectionId}/1` : '');
        this.pdfModalLoading = true;
        this.showPdfModal = true;
        await this.service.render();

        setTimeout(async () => {
            if (!this.showPdfModal || this.pdfModalToken !== token) return;
            this.pdfModalUrl = `${url}#page=1&view=FitH`;
            await this.service.render();
        }, 30);
    }

    public async onPdfModalLoaded() {
        this.pdfModalLoading = false;
        await this.service.render();
    }

    public async closePdfModal() {
        this.pdfModalToken++;
        this.showPdfModal = false;
        this.pdfModalDoc = null;
        this.pdfModalUrl = '';
        this.pdfModalPreviewUrl = '';
        this.pdfModalLoading = false;
        await this.service.render();
    }

    public async selectDocument(doc: any) {
        this.selectedDoc = doc;
        this.selectedDocTab = 'biblio';
        this.metadataEdit = this.defaultMetadataEdit(doc);
        await this.loadHistory(doc.id);
        await this.service.render();
    }

    public async clearSelectedDocument() {
        this.selectedDoc = null;
        await this.service.render();
    }

    public defaultMetadataEdit(doc: any): any {
        return {
            title: this.documentTitle(doc),
            author: doc?.author || doc?.hflib_author || '',
            publisher: doc?.publisher || doc?.hflib_publication || '',
            published_date: doc?.published_date || '',
            isbn: doc?.isbn || doc?.hflib_isbn || '',
            classification_scheme: doc?.classification_scheme || '',
            classification_no: doc?.classification_no || '',
            call_number: doc?.call_number || '',
            language: doc?.language || '',
            volume: doc?.volume || doc?.hflib_volume || '',
            source_url: doc?.source_url || '',
            source_board: doc?.source_board || '',
            source_article: doc?.source_article || '',
            bibliographic_status: doc?.bibliographic_status || 'draft'
        };
    }

    public async saveDocumentMetadata() {
        if (!this.selectedDoc) return;
        const { code, data } = await wiz.call("update_document_metadata", {
            id: this.selectedDoc.id,
            collection_id: this.collectionId,
            ...this.metadataEdit
        });
        if (code === 200) await this.load();
        else await this.service.modal.show({ title: '서지 저장 실패', message: data?.message || '서지정보를 저장할 수 없습니다.', action: '확인', cancel: false, status: 'error' });
    }

    public async loadHistory(docId?: string) {
        const { code, data } = await wiz.call("history", {
            collection_id: this.collectionId,
            document_id: docId || ''
        });
        if (code === 200) this.historyRows = data.history || [];
        const jobs = await wiz.call("jobs", { collection_id: this.collectionId });
        if (jobs.code === 200) this.jobRows = jobs.data.jobs || [];
    }

    public documentRowClass(last: boolean, doc: any): string {
        const base = 'group grid grid-cols-1 lg:grid-cols-12 gap-3 lg:gap-4 px-5 py-4 items-start lg:items-center hover:bg-stone-50/80 dark:hover:bg-stone-800/40 transition-colors cursor-pointer';
        const border = last ? '' : ' border-b border-stone-100 dark:border-stone-800';
        const selected = this.selectedDoc?.id === doc.id ? ' bg-sky-50/60 dark:bg-sky-900/20' : '';
        return base + border + selected;
    }

    public documentStorageText(doc: any): string {
        if (doc?.is_external) return '자료센터 외부 링크';
        if (doc?.has_local_file) return '자료함 저장 파일';
        return '파일 없음';
    }

    public documentSourceTitle(doc: any): string {
        return doc?.hflib_title || this.documentTitle(doc);
    }

    public documentSourceId(doc: any): string {
        const parts = [];
        if (doc?.hflib_biblio_id) parts.push(`서지 ${doc.hflib_biblio_id}`);
        if (doc?.hflib_resource_id) parts.push(`원문 ${doc.hflib_resource_id}`);
        return parts.join(' · ') || '-';
    }

    public bibliographyRows(doc: any): any[] {
        const biblio = doc?.nahf_biblio || {};
        return [
            { label: '저자', value: doc?.author || biblio.author || doc?.hflib_author || '' },
            { label: '발행처', value: doc?.publisher || doc?.hflib_publication || '' },
            { label: '발행일', value: doc?.published_date || biblio.published_date || '' },
            { label: 'ISBN', value: doc?.isbn || biblio.isbn || doc?.hflib_isbn || '' },
            { label: '분류', value: [doc?.classification_scheme, doc?.classification_no].filter(Boolean).join(' ') || biblio.category || doc?.hflib_volume || '' },
            { label: '청구기호', value: doc?.call_number || '' },
            { label: '언어', value: doc?.language || '' },
            { label: '사양', value: biblio.spec || (doc?.page_count ? `${doc.page_count}쪽` : '') },
            { label: '정가', value: biblio.price || '' },
        ].filter((row: any) => !!row.value);
    }

    public documentAuthorIntro(doc: any): string {
        return doc?.nahf_author_intro || doc?.hflib_author || '저자 정보가 없습니다.';
    }

    public documentBookIntro(doc: any): string {
        return doc?.nahf_book_intro || '도서 소개가 없습니다.';
    }

    public documentTocNote(doc: any): string {
        return doc?.nahf_toc_note || '차례는 아래 붙임파일 참고하시기 바랍니다.';
    }

    public documentAttachments(doc: any): any[] {
        return Array.isArray(doc?.nahf_attachments) ? doc.nahf_attachments : [];
    }

    // ===== Edit Modal =====
    public async openEditModal() {
        this.editData = {
            title: this.collection.title || '',
            description: this.collection.description || '',
            tags: [...(this.collection.tags || [])]
        };
        this.editNewTag = '';
        this.editNewTagColor = '#6366f1';
        this.showEditModal = true;
        await this.service.render();
    }

    public async closeEditModal() {
        this.showEditModal = false;
        await this.service.render();
    }

    public async addEditTag() {
        if (!this.editNewTag.trim()) return;
        const tag = this.editNewTag.trim();
        if (this.editData.tags.indexOf(tag) < 0) {
            this.editData.tags.push(tag);
        }
        if (!this.allTags.find((t: any) => t.name === tag)) {
            this.allTags.push({ name: tag, color: this.editNewTagColor });
        }
        this.editNewTag = '';
        this.editNewTagColor = '#6366f1';
        await this.service.render();
    }

    public async removeEditTag(idx: number) {
        this.editData.tags.splice(idx, 1);
        await this.service.render();
    }

    public async saveCollection() {
        if (!this.editData.title.trim()) {
            await this.service.alert.show({ title: '알림', message: '자료함 이름을 입력해주세요.' });
            return;
        }
        const tagColors: any = {};
        for (const tagName of this.editData.tags) {
            const t = this.allTags.find((x: any) => x.name === tagName);
            if (t?.color) tagColors[tagName] = t.color;
        }
        const { code } = await wiz.call("update_collection", {
            id: this.collectionId,
            title: this.editData.title,
            description: this.editData.description,
            tags: JSON.stringify(this.editData.tags),
            tag_colors: JSON.stringify(tagColors)
        });
        if (code === 200) {
            this.showEditModal = false;
            await this.load();
        }
    }

    public defaultLinkData(): any {
        return {
            title: '',
            sourceUrl: '',
            author: '',
            publication: '',
            isbn: '',
            volume: '',
            publishedDate: '',
            classificationScheme: 'KDC',
            classificationNo: '',
            callNumber: '',
            language: '한국어',
            sourceBoard: '수기 보관'
        };
    }

    public async openLinkModal(event?: Event) {
        if (event) event.stopPropagation();
        this.linkData = this.defaultLinkData();
        this.showLinkModal = true;
        await this.service.render();
    }

    public async closeLinkModal() {
        this.showLinkModal = false;
        await this.service.render();
    }

    public async createLinkDocument() {
        const title = String(this.linkData.title || '').trim();
        const sourceUrl = String(this.linkData.sourceUrl || '').trim();
        if (!title || !sourceUrl) {
            await this.service.modal.show({
                title: '입력 확인',
                message: '자료명과 원문 URL을 입력해주세요.',
                action: '확인',
                cancel: false
            });
            return;
        }

        const { code, data } = await wiz.call("create_link_document", {
            collection_id: this.collectionId,
            title,
            source_url: sourceUrl,
            author: this.linkData.author,
            publication: this.linkData.publication,
            isbn: this.linkData.isbn,
            volume: this.linkData.volume,
            published_date: this.linkData.publishedDate,
            classification_scheme: this.linkData.classificationScheme,
            classification_no: this.linkData.classificationNo,
            call_number: this.linkData.callNumber,
            language: this.linkData.language,
            source_board: this.linkData.sourceBoard
        });

        if (code === 200) {
            this.showLinkModal = false;
            await this.load();
        } else {
            await this.service.modal.show({
                title: '외부 링크 보관 실패',
                message: data?.message || '외부 링크를 보관할 수 없습니다.',
                action: '확인',
                cancel: false,
                status: 'error'
            });
        }
    }

    // ===== Drag & Drop =====
    public onDragOver(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.dragOver = true;
    }

    public onDragLeave(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.dragOver = false;
    }

    public async onDrop(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        this.dragOver = false;
        const files = event.dataTransfer?.files;
        if (files && files.length > 0) {
            await this.uploadFiles(files);
        }
    }

    public async onFileSelect(event: any) {
        const files = event.target.files;
        if (files && files.length > 0) {
            await this.uploadFiles(files);
        }
        if (this.fileInput) {
            this.fileInput.nativeElement.value = '';
        }
    }

    // ===== Upload with Progress =====
    public async uploadFiles(files: FileList) {
        const allFiles = Array.from(files);
        const acceptedFiles = allFiles.filter(file => this.isSupportedFile(file));
        const rejectedCount = allFiles.length - acceptedFiles.length;
        if (acceptedFiles.length === 0) {
            await this.service.modal.show({
                title: '업로드 오류',
                message: `지원하는 자료 형식이 없습니다. 지원 형식: ${this.supportedFileLabel}`,
                action: '확인',
                cancel: false
            });
            return;
        }

        this.uploading = true;
        this.uploadProgressPct = 0;
        this.uploadFileName = '';
        this.uploadQueue = acceptedFiles.map((file: File) => ({
            name: file.name,
            size: file.size,
            type: this.documentFormat({ filename: file.name }),
            status: this.isPdfDocument({ filename: file.name }) ? '분석 대기' : '원본 보관',
            duplicate: false
        }));
        await this.service.render();

        let successCount = 0;
        let failCount = 0;

        for (let i = 0; i < acceptedFiles.length; i++) {
            const file = acceptedFiles[i];
            this.uploadFileName = file.name;
            this.uploadProgressPct = 0;
            await this.service.render();

            try {
                const result: any = await new Promise((resolve, reject) => {
                    const xhr = new XMLHttpRequest();
                    xhr.upload.addEventListener('progress', async (e) => {
                        if (e.lengthComputable) {
                            const filePct = Math.round((e.loaded / e.total) * 100);
                            this.uploadProgressPct = Math.round((i / acceptedFiles.length) * 100 + filePct / acceptedFiles.length);
                            await this.service.render();
                        }
                    });
                    xhr.addEventListener('load', () => {
                        try { resolve(JSON.parse(xhr.responseText)); }
                        catch { reject(new Error('Invalid response')); }
                    });
                    xhr.addEventListener('error', () => reject(new Error('Upload failed')));

                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('collection_id', this.collectionId);
                    xhr.open('POST', `/wiz/api/page.collections.item/upload`);
                    xhr.send(formData);
                });

                if (result.code === 200) {
                    successCount += (result.data?.uploaded || 0);
                    const duplicateFiles = result.data?.duplicate_files || [];
                    for (const item of this.uploadQueue) {
                        if (duplicateFiles.indexOf(item.name) >= 0) {
                            item.duplicate = true;
                            item.status = '중복 제외';
                        } else if (item.name === file.name) {
                            item.status = '입수 완료';
                        }
                    }
                } else {
                    failCount++;
                    const queueItem = this.uploadQueue.find((item: any) => item.name === file.name);
                    if (queueItem) queueItem.status = '실패';
                }
            } catch (e) {
                failCount++;
                const queueItem = this.uploadQueue.find((item: any) => item.name === file.name);
                if (queueItem) queueItem.status = '실패';
            }
        }

        this.uploading = false;
        this.uploadProgressPct = 0;
        this.uploadFileName = '';

        if (failCount > 0 || rejectedCount > 0) {
            const rejectedText = rejectedCount > 0 ? `, ${rejectedCount}개 형식 제외` : '';
            await this.service.modal.show({
                title: '업로드 결과',
                message: `${successCount}개 성공, ${failCount}개 실패${rejectedText}`,
                action: '확인',
                cancel: false
            });
        }

        await this.load();
    }

    public triggerFileInput() {
        if (this.fileInput) {
            this.fileInput.nativeElement.click();
        }
    }

    // ===== Step & Progress Helpers =====
    private progressToStep(pct: number): number {
        if (pct <= 0) return 0;
        if (pct < 45) return 1;   // 문서 인식 (OCR): 5~40
        if (pct < 80) return 2;   // 내용 분석 (임베딩): 45~75
        if (pct < 100) return 3;  // 저장 (벡터 DB): 80~95
        return 4;
    }

    private calcEta(progressPct: number): string {
        if (progressPct <= 5 || !this.registerStartTime) return '';
        const elapsed = (Date.now() - this.registerStartTime) / 1000;
        const remaining = elapsed * (100 - progressPct) / progressPct;
        if (remaining < 5) return '곧 완료';
        if (remaining < 60) return `${Math.round(remaining)}초`;
        return `${Math.round(remaining / 60)}분`;
    }

    public stepClass(step: number): string {
        if (this.registerStopped && this.registerStep === step) {
            return 'border-orange-400 bg-orange-50 text-orange-600 dark:bg-orange-900/30 dark:border-orange-500 dark:text-orange-400';
        }
        if (this.registerStep > step || (this.registerStep === 4 && step <= 3)) {
            return 'border-green-400 bg-green-50 text-green-600 dark:bg-green-900/30 dark:border-green-500 dark:text-green-400';
        }
        if (this.registerStep === step) {
            return 'border-stone-700 bg-stone-100 text-stone-700 dark:border-stone-300 dark:bg-stone-700 dark:text-stone-200 animate-pulse';
        }
        return 'border-stone-200 bg-white text-stone-400 dark:border-stone-700 dark:bg-stone-800 dark:text-stone-500';
    }

    // ===== 개별 원문 분석 =====
    public async registerDocument(doc: any) {
        this.registeringDocId = doc.id;
        this.registeringDocName = doc.filename;
        this.registerProgress = '원문 분석을 준비하고 있습니다...';
        this.registerProgressPct = 0;
        this.registerStep = 0;
        this.registerStopped = false;
        this.registerEta = '';
        this.registerStartTime = Date.now();
        await this.service.render();

        const { code, data } = await wiz.call("register", { doc_id: doc.id, collection_id: this.collectionId });
        if (code !== 200) {
            this.registeringDocId = '';
            this.registerProgress = '';
            this.registerStep = 0;
            await this.service.modal.show({
                title: '원문 분석 실패',
                message: data?.message || '분석을 시작할 수 없습니다.',
                action: '확인',
                cancel: false,
                status: 'error'
            });
            await this.service.render();
            return;
        }

        await this.pollRegisterStatus(doc.id);
    }

    private async pollRegisterStatus(docId: string) {
        while (this.registeringDocId === docId) {
            await new Promise(r => setTimeout(r, 1500));
            const res = await wiz.call("register_status", { doc_id: docId });
            if (res.code !== 200) break;

            const { status, progress, progress_message } = res.data;
            this.registerProgressPct = progress || 0;
            this.registerStep = this.progressToStep(this.registerProgressPct);
            this.registerProgress = progress_message || '처리 중...';
            this.registerEta = this.calcEta(this.registerProgressPct);
            await this.service.render();

            if (status === 'completed') {
                this.registerStep = 4;
                this.registerProgressPct = 100;
                this.registerProgress = '원문 분석이 완료되었습니다!';
                this.registerEta = '';
                await this.service.render();
                await new Promise(r => setTimeout(r, 1200));
                break;
            }
            if (status === 'cancelled') {
                this.registerStopped = true;
                this.registerProgress = '분석이 중단되었습니다.';
                this.registerEta = '';
                await this.service.render();
                await new Promise(r => setTimeout(r, 2000));
                break;
            }
            if (status === 'failed') {
                this.registeringDocId = '';
                this.registerProgress = '';
                this.registerStep = 0;
                await this.service.modal.show({
                    title: '원문 분석 실패',
                    message: res.data.error_message || '알 수 없는 오류',
                    action: '확인',
                    cancel: false,
                    status: 'error'
                });
                await this.load();
                return;
            }
        }

        this.registeringDocId = '';
        this.registerProgress = '';
        this.registerStep = 0;
        this.registerStopped = false;
        this.registerEta = '';
        await this.load();
    }

    // ===== 분석 취소 =====
    public async cancelRegister() {
        const confirm = await this.service.modal.show({
            title: '분석 중단',
            message: '현재 진행 중인 분석을 중단하시겠습니까?\n이미 처리된 단계까지만 저장됩니다.',
            action: '멈추기',
            actionBtn: 'error'
        });
        if (!confirm) return;
        await wiz.call("cancel_register", { doc_id: this.registeringDocId });
    }

    public async cancelBatch() {
        const confirm = await this.service.modal.show({
            title: '일괄 분석 중단',
            message: '전체 원문 분석을 중단하시겠습니까?\n이미 완료된 자료는 유지됩니다.',
            action: '멈추기',
            actionBtn: 'error'
        });
        if (!confirm) return;
        this.batchStopped = true;
        await wiz.call("cancel_register_all", { collection_id: this.collectionId });
        await this.service.render();
    }

    // ===== 일괄 원문 분석 =====
    public get pendingCount(): number {
        return this.pendingOnlyCount;
    }

    public async registerAll() {
        if (this.batchRegistering) return;
        const count = this.retryableCount;
        if (count === 0) {
            await this.service.modal.show({ title: '알림', message: '분석할 PDF 문서가 없습니다.', action: '확인', cancel: false });
            return;
        }

        this.batchRegistering = true;
        this.batchTotal = count;
        this.batchCompleted = 0;
        this.batchFailed = 0;
        this.batchCurrentDoc = null;
        this.batchStopped = false;
        this.batchCurrentStep = 0;
        this.batchOverallPct = 0;
        this.batchDone = false;
        this.batchDoneMessage = '';
        await this.service.render();

        const { code, data } = await wiz.call("register_all", { collection_id: this.collectionId });
        if (code !== 200) {
            this.batchRegistering = false;
            await this.service.modal.show({
                title: '일괄 분석 실패',
                message: data?.message || '분석을 시작할 수 없습니다.',
                action: '확인',
                cancel: false,
                status: 'error'
            });
            await this.service.render();
            return;
        }

        while (this.batchRegistering) {
            await new Promise(r => setTimeout(r, 1500));
            const res = await wiz.call("register_all_status", { collection_id: this.collectionId });
            if (res.code !== 200) break;

            const { total, completed, failed, done, current_doc, cancelled } = res.data;
            this.batchTotal = total;
            this.batchCompleted = completed;
            this.batchFailed = failed;
            this.batchCurrentDoc = current_doc;

            // Calculate current doc step from progress
            if (current_doc && current_doc.progress) {
                this.batchCurrentStep = this.progressToStep(current_doc.progress);
            } else {
                this.batchCurrentStep = 0;
            }

            // Overall progress: completed docs + current doc partial
            const denominator = total || this.batchTotal || 1;
            const completedPart = (completed + failed) / denominator * 100;
            const currentPart = current_doc ? (current_doc.progress || 0) / denominator : 0;
            this.batchOverallPct = Math.min(100, Math.round(completedPart + currentPart));

            await this.service.render();

            if (done) {
                this.batchRegistering = false;
                this.batchCurrentDoc = null;
                this.batchOverallPct = 100;
                if (this.batchStopped || cancelled) {
                    await this.service.render();
                    await new Promise(r => setTimeout(r, 3000));
                    this.batchStopped = false;
                } else {
                    // Show styled done state
                    this.batchDone = true;
                    this.batchDoneMessage = `${completed}개 문서 분석 완료`;
                    if (failed > 0) this.batchDoneMessage += `, ${failed}개 실패`;
                    await this.service.render();
                }
                await this.load();
                return;
            }
        }
    }

    public async closeBatchDone() {
        this.batchDone = false;
        this.batchDoneMessage = '';
        await this.service.render();
    }

    // ===== Preview Modal =====
    public async openPreviewModal(doc: any) {
        this.previewDoc = doc;
        this.previewLoading = true;
        this.previewPages = [];
        this.previewCurrentPage = 1;
        this.previewTotalPages = 0;
        this.showPreviewModal = true;
        this.previewPageImgUrl = '';
        await this.service.render();

        const { code, data } = await wiz.call("get_extracted_text", { doc_id: doc.id });
        if (code === 200) {
            const text = data.extracted_text || '';
            this.previewPages = this.splitByPages(text);
            this.previewTotalPages = this.previewPages.length;
            if (this.previewTotalPages === 0) {
                this.previewPages = [text || '추출된 텍스트가 없습니다.'];
                this.previewTotalPages = 1;
            }
        } else {
            this.previewPages = ['텍스트를 불러올 수 없습니다.'];
            this.previewTotalPages = 1;
        }
        this.previewPagesHtml = this.previewPages.map(p => this.formatExtractedText(p));

        this.updatePageImgUrl();
        this.previewLoading = false;
        await this.service.render();
    }

    private formatExtractedText(text: string): string {
        if (!text) return '';
        let s = text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        // 빈 줄(\n\n+) 기준으로 단락 분리
        const blocks = s.split(/\n{2,}/);
        return blocks
            .map(b => b.trim())
            .filter(b => b)
            .map(b => '<div class="text-block">' + b.replace(/\n/g, '<br>') + '</div>')
            .join('');
    }

    private splitByPages(text: string): string[] {
        const parts = text.split(/\[페이지\s*\d+\]/).filter(p => p.trim());
        if (parts.length <= 1) {
            const altParts = text.split(/\[Page\s*\d+\]/).filter(p => p.trim());
            if (altParts.length > 1) return altParts.map(p => p.trim());
        }
        return parts.length > 0 ? parts.map(p => p.trim()) : [text];
    }

    private updatePageImgUrl() {
        if (!this.previewDoc) return;
        this.previewPageImgUrl = `/api/pdf/${this.previewDoc.id}/${this.collectionId}/${this.previewCurrentPage}`;
    }

    public async goToPage(page: number) {
        if (page < 1 || page > this.previewTotalPages) return;
        this.previewCurrentPage = page;
        this.updatePageImgUrl();
        await this.service.render();
    }

    public async closePreviewModal() {
        this.showPreviewModal = false;
        this.previewDoc = null;
        this.previewPages = [];
        this.previewPagesHtml = [];
        this.previewPageImgUrl = '';
        await this.service.render();
    }

    // ===== Helpers =====
    public statusText(status: string) {
        const map: any = {
            'pending': '분석 대기', 'processing': '원문 분석 중', 'completed': '활용 가능',
            'failed': '분석 오류', 'cancelled': '분석 중단', 'external': '링크 보관', 'archived': '원본 보관'
        };
        return map[status] || status;
    }

    public statusColor(status: string) {
        const map: any = {
            'pending': 'text-stone-500 bg-stone-100 dark:text-stone-400 dark:bg-stone-800',
            'external': 'text-sky-700 bg-sky-50 dark:text-sky-300 dark:bg-sky-900/30',
            'archived': 'text-teal-700 bg-teal-50 dark:text-teal-300 dark:bg-teal-900/30',
            'processing': 'text-orange-600 bg-orange-50 dark:text-orange-400 dark:bg-orange-900/30',
            'completed': 'text-green-600 bg-green-50 dark:text-green-400 dark:bg-green-900/30',
            'failed': 'text-red-600 bg-red-50 dark:text-red-400 dark:bg-red-900/30',
            'cancelled': 'text-orange-500 bg-orange-50 dark:text-orange-400 dark:bg-orange-900/30'
        };
        return map[status] || 'text-stone-500 bg-stone-100 dark:text-stone-400 dark:bg-stone-800';
    }

    // ===== Reembed =====
    public reembedding: boolean = false;

    public async reembed() {
        const confirm = await this.service.modal.show({
            title: '벡터 재생성',
            message: '모든 완료된 문서의 벡터를 재생성합니다.\n시간이 걸릴 수 있습니다.',
            action: '재생성',
            actionBtn: 'warning'
        });
        if (!confirm) return;

        this.reembedding = true;
        await this.service.render();

        const { code, data } = await wiz.call("reembed", { collection_id: this.collectionId });

        this.reembedding = false;
        if (code === 200) {
            await this.service.modal.show({
                title: '완료',
                message: `${data.doc_count}개 문서, ${data.total_chunks}개 청크 재생성 완료`,
                action: '확인',
                cancel: false
            });
        } else {
            await this.service.modal.show({
                title: '오류',
                message: data?.message || '재생성 중 오류가 발생했습니다.',
                action: '확인',
                cancel: false,
                status: 'error'
            });
        }
        await this.service.render();
    }

    public async deleteDocument(docId: string) {
        const res = await this.service.modal.show({
            title: '휴지통 이동', message: '이 문서를 휴지통으로 이동하시겠습니까?', action: '이동', actionBtn: 'error'
        });
        if (!res) return;
        const { code } = await wiz.call("delete_document", { id: docId, collection_id: this.collectionId });
        if (code === 200) await this.load();
    }

    public async restoreDocument(docId: string, event?: Event) {
        if (event) event.stopPropagation();
        const { code } = await wiz.call("restore_document", { id: docId, collection_id: this.collectionId });
        if (code === 200) await this.load();
    }

    public async emptyTrash() {
        const res = await this.service.modal.show({
            title: '휴지통 비우기', message: '휴지통 문서를 영구 삭제하시겠습니까?', action: '영구 삭제', actionBtn: 'error'
        });
        if (!res) return;
        const { code } = await wiz.call("empty_trash", { collection_id: this.collectionId });
        if (code === 200) await this.load();
    }

    public formatSize(bytes: number) {
        if (!bytes) return '0 B';
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / 1048576).toFixed(1) + ' MB';
    }
}

export default PageCollectionsItemComponent;